export default {
  props: {
    image: {
      type: Object,
    },

    title: {
      type: Object,
    },

    subtitle: {
      type: String,
    },

    paragraph: {
      type: String,
    },

    list: {
      type: Array,
    },

    secondSubtitle: {
      type: String,
    },

    buttons: {
      type: Array,
    },
  },

  computed: {
    withoutImage() {
      return this.image ? '' : 'content-block--without-image'
    },
  },
}
